/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

$(function () {
    // 別ページの場合は以下
  var urlHash = location.hash;
  if (urlHash) {
    if($(urlHash)[0]) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function(){

        var gap = 0;

        gap = $('.l-header').innerHeight();

        var ancGap = parseInt($(urlHash).attr('data-anc-gap'));
        if(ancGap) {
          gap += ancGap;
        }

        var target = $(urlHash);
        var position = target.offset().top - gap;
        $('body,html').stop().animate({scrollTop:position}, 0);
      }, 100);
    }
  }
});

$(function(){
  $('.home-kvSlider__slick').each(function(index, el) {
    const $slider = $(this);
    const $kv = $('.home-kv');

    setTimeout(function(){
      $kv.addClass('is-show');

      $slider.slick({
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        speed: 1500,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        arrows: false,
        dots: true
      });
    }, 400);
  });
});

$(function(){
  $('.worksSingle-slider__slick').each(function(index, el) {
    const $slider = $(this);
    const $cnt = $('.worksSingle-slider__cnt');
    let now = 0;
    let total = 0;

    setTimeout(function(){

      $slider.on('init', function(event, slick) {
        now = slick.currentSlide + 1;
        total = slick.slideCount;

        runCnt();
      })
      .slick({
        arrows: true,
        dots: false
      })
      .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        now = nextSlide + 1;

        runCnt();
      });

      function runCnt() {
        $cnt.html(now + '/' + total);
      }
    }, 0);
  });
});

//fade
$(function(){
  var fade = $('.u-fade, .u-ani');
  let isFlow = false;

  fade.each(function(index, el) {
    var t = $(this);

    setTimeout(function(){
      $(window).on('resize scroll', function(event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 0;

      var h = t.attr('data-fade-h');
      if(h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if(sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if(d) {
        pointD = d;
      }

      if(pointH < pointSc) {
        setTimeout(function(){
          t.addClass('is-fade');
          next();

          if(!isFlow && t.hasClass('recruit-flow__items')) {
            isFlow = true;
            setTimeout(function(){
              flowFade();
            }, 7000);
          }
        }, pointD);
      }
    }

    function flowFade() {
      const $flow = $('.recruit-flow__items');

      setTimeout(function(){ $flow.addClass('is-fadeOut'); }, 0);
      setTimeout(function(){ $flow.removeClass('is-fade is-fadeOut'); }, 1500);
      setTimeout(function(){ $flow.addClass('is-fade'); }, 1700);
      setTimeout(function(){ flowFade(); }, 7000);
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if(nextStr) {
        var nextArr = nextStr.split(' ');
        if(nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if(nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 0;
              if(nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 0;
              if(nextDelay) {
                step = delay;
              }
              if(nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function(index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function(){
                  t2.addClass('is-fade-next');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

$(function(){
  const $menu = $('.p-hd__menu a');

  if($menu[0]) {
    const $nav = $('.p-hd__nav');

    $menu.on('click', function(event) {
      $menu.toggleClass('is-on');
      $nav.toggleClass('is-show');
    });
  }
})

$(function(){
  const $more = $('.works-posts__more');

  if($more[0]) {
    const $hide = $('.works-posts__post.is-hide');

    $more.on('click', function(event) {
      $hide.removeClass('is-hide');
      $more.hide();

      setTimeout(function(){
        $hide.removeClass('is-hide2');
      }, 10);
    });
  }
})

jQuery(function() {
  const Select = jQuery('.contact-form__input select');

  jQuery(Select).addClass('is-noVal').on('change', function(){
    if (jQuery(Select).val() !== ""){
      jQuery(this).removeClass('is-noVal');
    } else {
      jQuery(this).addClass('is-noVal');
    }
  });

  setTimeout(function(){
    if (jQuery(Select).val() !== ""){
      jQuery(Select).removeClass('is-noVal');
    } else {
      jQuery(Select).addClass('is-noVal');
    }
  }, 10);
});

$(function(){
  const $sel = $('.works-catnav__select select');

  if($sel[0]) {
    $sel.on('change', function(event) {
      let url = $(this).val();

      if(url) {
        window.location.href = url;
      }
    });
  }
})

//初期値
$('.works-selectBox__output').each(function () {
  let defaultText = '';
  const $pageItem = $(this).next('.works-selectBox__selector').find('.works-selectBox__selectorItem.is-page');
  const $firstItem = $(this).next('.works-selectBox__selector').children('.works-selectBox__selectorItem:first-child');

  if($pageItem[0]) {
    defaultText = $pageItem.text();
    $pageItem.hide();
  } else {
    defaultText = $firstItem.text()
    $firstItem.hide();
  }

  $(this).text(defaultText);
})

//出力の枠をクリックした時の動作
$('.works-selectBox__output').on('click', function (e) {
  e.stopPropagation();
  if ($(this).hasClass('open')) {
    $(this).next('.works-selectBox__selector').slideUp();
  } else {
    $(this).next('.works-selectBox__selector').slideDown();
  }
  $(this).toggleClass('open');
});

//選択肢をクリックした時の動作
$('.works-selectBox__selectorItem').on('click', function () {
  const selectVal = $(this).data('select');
  const selectText = $(this).text();
  $(this).parent('.works-selectBox__selector').prev('.works-selectBox__output').text(selectText).removeClass('open');
  $(this).parent('.works-selectBox__selector').slideUp();
  $(this).parents('.works-selectBox__output').slideDown();
//  $('.works-catnav__selectTar').val(selectVal);

  setTimeout(function() {
    let url = selectVal;

    if(url) {
      window.location.href = url;
    }
  }, 100);
});


$(function(){
  const $root = $('.contact-form__inputSel');

  if($root[0]) {
    $root.each(function(index, el) {
      const $selWrap = $(this);
      const $sel = $selWrap.find('select');
      const $link = $selWrap.find('.contact-form__inputSelItemsLink');
      const $items = $selWrap.find('.contact-form__inputSelItems');
      const $item = $selWrap.find('.contact-form__inputSelItem');

      $link.on('click', function(event) {
        $items.stop().slideToggle();
      });

      $item.on('click', function(event) {
        const $t = $(this);
        let val = $t.text();

        $items.stop().slideUp();
        $sel.val(val).removeClass('is-noVal');
      });
    });
  }
})
